// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__Y1Dem","link--active":"styles_link--active__DnZsH"};